
const ChatGptModel = {
  ChatGpt35Turbo: "gpt-3.5-turbo",
  ChatGpt4Turbo: "gpt-4-0125-preview",
  ChatGpt4o: "gpt-4o-2024-08-06",
  ChatGpt4oMini: "gpt-4o-mini",
}


export default ChatGptModel;